import { Component, Input, Output, EventEmitter } from '@angular/core';
import { icons } from "../data.model";

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  @Input() public notification;
  @Output() public onCloseNotification = new EventEmitter();
  public icons = icons;

  public clearNotification() {
    this.onCloseNotification.emit({shown: false, status: null, message: null});
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/notification/notification.component.ts